import { Component } from "@angular/core";
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { addOnForm } from "src/app/core/models/add-on.model";
import { ProductService } from "src/app/core/services/product.service";
import { SharedService } from "src/app/core/services/shared.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { UploadGalleryComponent } from "src/app/shared/ui/upload-gallery/upload-gallery.component";
import * as ClassicEditor from "@ckeditor/ckeditor5-build-classic";

@Component({
  selector: "app-add-on-insurance",
  templateUrl: "./add-on-insurance.component.html",
  styleUrls: ["./add-on-insurance.component.scss"],
})
export class AddOnInsuranceComponent {
  constructor(
    private sharedService: SharedService,
    private api: ProductService,
    private fb: FormBuilder,
    private tosatr: ToastrService,
    private modalService: NgbModal
  ) { }

  countryList = this.sharedService.addedCountryList;
  country = this.sharedService.selectedCountryId;
  addOnForm: FormGroup;
  isUpdated: boolean = false;
  typeId: any;
  selected = false;
  public Editor = ClassicEditor;
  editorConfig = {
    toolbar: {
      items: [
        'bold',
        'italic',
        'link',
        '|',
        'undo',
        'redo',
      ],
    },
  };

  ngOnInit(): void {
    this.initForm();
    if (this.countryList.length == 0) this.getCountriesList();
  }

  getAddOnForm() {
    this.selectCountry(this.country);
    this.api.getAddOnData(this.country).subscribe((res) => {
      this.initForm(res[0]);
      this.isUpdated = res[0]?.id ? true : false;
      this.typeId = res[0]?.id;
    });
  }

  selectCountry(country) {
    this.country = country;
    this.sharedService.selectedCmsCountryId = country;
    this.sharedService.selectedCmsCategoryId = null;
    this.sharedService.cmsCategoryList = [];

    this.sharedService.selectedCmsProductId = null;
    this.sharedService.cmsProductList = [];
  }

  initForm(data?: any) {
    this.addOnForm = this.fb.nonNullable.group<addOnForm>({
      heading: new FormControl(data?.heading ?? null, Validators.required),
      price_heading: new FormControl(data?.price_heading ?? null, Validators.required),
      logo: new FormControl(data?.logo ?? null, Validators.required),
      info: this.fb.array(
        (data?.info ?? []).map((info: any) =>
          this.fb.group({
            text: new FormControl(info?.text ?? '', Validators.required),
            icon: new FormControl(info?.icon ?? '', Validators.required),
            is_updated: new FormControl(false),
            is_new: new FormControl(false),
          })
        )
      ),
      benefits: this.fb.array(
        (data?.benefits ?? []).map((benefit: string) => new FormControl(benefit, Validators.required))
      ),
      snackbar: new FormControl(data?.snackbar ?? null, Validators.required),
      insurance: new FormControl(data?.key_values[0]?.Insurance ?? null, Validators.required),
      insurance_71_80: new FormControl(data?.key_values[0]?.Insurance_71_80 ?? null, Validators.required),

    });
  }

  get info(): FormArray {
    return this.addOnForm.get('info') as FormArray;
  }

  addInfo() {
    this.info.push(
      this.fb.group({
        text: new FormControl('', Validators.required),
        icon: new FormControl('', Validators.required),
        is_updated: new FormControl(false),
        is_new: new FormControl(true),
      })
    );
  }

  removeInfo(index: number) {
    this.info.removeAt(index);
  }

  get benefits(): FormArray {
    return this.addOnForm.get('benefits') as FormArray;
  }

  addBenefit() {
    this.benefits.push(new FormControl('', Validators.required));
  }

  removeBenefit(index: number) {
    this.benefits.removeAt(index);
  }

  submitAddOn() {
    if (!this.addOnForm.valid) {
      this.addOnForm.markAllAsTouched();
      this.tosatr.warning("Fill All Fields!");
      return;
    }

    const cleanedBenefits = this.addOnForm.value.benefits.map(ae => this.cleanHTMLContent(ae));
    this.addOnForm.get('benefits')?.setValue(cleanedBenefits);

    const formData = {
      ...this.addOnForm.value,
      country: this.country,
      key_values: [{
        Insurance: this.addOnForm.get("insurance").value,
        Insurance_71_80: this.addOnForm.get("insurance_71_80").value
      }]
    };

    const apiCall = this.isUpdated
      ? this.api.editAddOnData(this.typeId, formData)
      : this.api.postAddOnData(formData);

    apiCall.subscribe({
      next: (res) => {
        const successMessage = this.isUpdated
          ? "Insurance Details Updated successfully"
          : "Insurance Details Added successfully";
        this.tosatr.success("Success", successMessage);
        this.getAddOnForm();
      },
      error: (err) => {
        this.tosatr.error("Error", "An error occurred while processing your request.");
        console.error(err);
      },
    });
  }

  getCountriesList() {
    this.api.getCountryDetails().subscribe((response: any) => {
      this.countryList = response;
      this.sharedService.addedCountryList = this.countryList;
      this.selected = true;
    });
  }

  openUploadModal(field, i?) {
    const modalRef = this.modalService.open(UploadGalleryComponent,
      {
        size: 'xl',
        scrollable: true,
        windowClass: 'modal-big-lg',
        keyboard: false,
        backdrop: 'static'
      });
    modalRef.componentInstance.uploadDetails = {};
    modalRef.result.then((result) => {
      if (result.status) {
        if (i >= 0) {
          console.log(field, i);
          this.addOnForm.get(['info', i, field]).setValue(result.image);
          this.addOnForm.get(['info', i, 'is_updated']).setValue(true);
        }
        else this.addOnForm.get(field).setValue(result.image);
      }
    });
  }

  dataChanged(i) {
    this.addOnForm.value.info[i].is_updated = true;
  }

  cleanHTMLContent(content: string): string {
    content = content.trim();

    if (content.startsWith('<p>')) {
      content = content.replace(/^<p[^>]*>/, '');
    }

    if (content.endsWith('</p>')) {
      content = content.replace(/<\/p>$/, '');
    }

    return content;
  }

}
